import {Language} from "modules/enums";
import logo from "assets/images/neon-logo.png";
import logoFr from "assets/images/neon-fr-logo.png";
import logoGzEn from "assets/images/cfl-gz-logo.png";
import logoGzFr from "assets/images/cfl-gz-logo-fr.png";

export const getLogo = (lang: string) => (lang === Language.English ? logo : logoFr);

export const getGzLogo = (lang: string) => (lang === Language.English ? logoGzEn : logoGzFr);
